import { resolveStorageUrl } from "../../utils/adminApiHelpers";
import { isPlainObject } from "../../utils/objectHelpers";

export function normalizePartnerItem(raw) {
  if (!raw || typeof raw !== "object") return null;
  const item =
    raw.attributes && typeof raw.attributes === "object" ? raw.attributes : raw;
  const id = item.id ?? raw.id;
  if (id == null) return null;

  const nameObj = isPlainObject(item.name) ? item.name : null;
  const name_ar = String(
    nameObj?.ar ?? item.name_ar ?? item.nameAr ?? ""
  ).trim();
  const name_en = String(
    nameObj?.en ??
      item.name_en ??
      item.nameEn ??
      (typeof item.name === "string" ? item.name : "") ??
      ""
  ).trim();

  const full = item.logo_url;
  let logo_url = "";
  if (full != null && typeof full === "string" && full.trim()) {
    logo_url = full.trim();
  } else if (item.logo) {
    logo_url = resolveStorageUrl(String(item.logo));
  }

  return { id, name_ar, name_en, logo_url };
}
